<template>
    <div>
        <main role="main" class="background-employer-dashboard background-employer-dashboard-bottom pb-5">
            <div class="container">
                <nav aria-label="breadcrumb" class="mt-4">
                    <ol class="breadcrumb font-poppins font-weight-light font-size-14 color-blue px-0 bg-white">
                        <li class="breadcrumb-item">
                            <a
                                :href="route('nl.employerdashboard.employees.overview', $page.props.auth.user.selected_company.uuid)"
                                class="font-poppins font-weight-semibold color-blue">
                                {{ Lang.get('employerdashboard::pages/employee/breadcrumb.overview') }}</a>
                        </li>
                        <li class="breadcrumb-item">
                            <a
                                :href="route('nl.employerdashboard.employee.profile', {company_as_uuid: $page.props.auth.user.selected_company.uuid, employee_uuid: employee.uuid})"
                                class="font-poppins font-weight-semibold color-blue">
                                {{ Lang.get('employerdashboard::pages/employee/breadcrumb.profile') }}</a>
                        </li>
                        <li class="breadcrumb-item color-blue" aria-current="page">
                            {{ Lang.get('employerdashboard::pages/employee/breadcrumb.transactions') }}</li>
                    </ol>
                </nav>
                <h1 class="title font-poppins color-blue mt-4">{{ Lang.get('employerdashboard::pages/employee/transactions.title', {fullname: employee.fullname}) }}</h1>
                <h6 class="font-poppins font-weight-light font-size-18 color-blue">{{ Lang.get('employerdashboard::pages/employee/transactions.subtitle') }}</h6>
                <div class="row mt-5">
                    <div class="col-12 col-md-10 mb-4">

                        <div class="alert alert-warning" v-if="employee.is_anonymous">
                            <i class="fa fa-exclamation-circle pr-2"></i>
                            <template v-if="employee.is_disabled_from_participation">
                                {{ Lang.get('employerdashboard::shared.is_disabled_from_participation') }}
                            </template>
                            <p class="pt-2 pl-4">
                                <strong>{{ Lang.get('employerdashboard::pages/employee/profile.explanation') }}:</strong><br />
                                <span>{{ employee.disabled_from_participation_reason }}</span><br />
                                <span>{{ Lang.get('employerdashboard::shared.is_disabled_from_participation_transactions_overview_explanation') }}</span>
                            </p>

                            <p class="pt-1 pl-4" v-html="Lang.get('employerdashboard::pages/employee/profile.disabled_from_participation.footer', {reference: employee.disabled_from_participation_reference})"></p>
                        </div>

                        <div class="card border-radius-8 shadow">
                            <div class="card-body px-0 py-2">
                                <div class="tab-pane fade show active">
                                    <div id="budgetsAccordion">
                                        <div class="card border-0" v-for="(employeeData, period) in employee.transactions.data" :key="replaceSpace(period)">
                                            <div class="card-header px-4 py-3 bg-white cursor-pointer collapsed color-dark-blue-on-hover border-bottom" :id="'heading_' + replaceSpace(period)" data-toggle="collapse" :data-target="'#collapse_' + replaceSpace(period)" aria-expanded="false" :aria-controls="'collapse_' + replaceSpace(period)">
                                                <div class="row color-dark-blue-on-hover">
                                                    <div class="col-6">
                                                         <span class="font-poppins font-weight-light font-size-18 color-blue color-dark-blue-on-hover">
                                                            {{ period }}
                                                        </span>
                                                    </div>
                                                    <div class="col">
                                                        <span class="font-poppins font-weight-light font-size-18 color-blue float-left color-dark-blue-on-hover">
                                                            {{ employeeData.transactions_qty }}
                                                        </span>
                                                    </div>

                                                    <div class="col">
                                                        <span
                                                            class="badge font-poppins font-size-14 font-weight-semibold mt-1 badge-success"
                                                            v-if="employeeData.iob && employeeData.synced">
                                                        {{ employeeData.title }}</span>
                                                        <span
                                                            class="badge font-poppins font-size-14 font-weight-semibold mt-1 badge-danger"
                                                            v-if="!employeeData.iob && employeeData.synced">
                                                        {{ employeeData.title }}</span>
                                                        <span
                                                            class="badge font-poppins font-size-14 font-weight-semibold mt-1 badge-warning color-white"
                                                            v-if="!employeeData.synced">
                                                        {{ employeeData.title }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div :id="'collapse_' + replaceSpace(period)" class="collapse" :aria-labelledby="'heading' + replaceSpace(period)" data-parent="#budgetsAccordion">
                                                <div class="card-body border-bottom font-poppins font-weight-light color-dark-blue px-4">
                                                    <template v-if="!employeeData.iob && !employeeData.synced && !employee.is_anonymous">
                                                        <div class="bg-info-light py-2 pl-2">
                                                            <h4>
                                                                <i class="fa fa-exclamation-circle pr-2"></i>
                                                                {{ employeeData.response.title }}</h4>
                                                            <p class="pt-2 pl-4 font-weight-semibold">{{ Lang.get('employerdashboard::pages/employee/transactions.explanation') }}:<br />
                                                                <span class="font-weight-lighter" v-html="employeeData.response.description"></span>
                                                            </p>
                                                        </div>
                                                    </template>

                                                    <template v-if="employeeData.iob && !employee.is_anonymous">
                                                        <div class="bg-info-light py-2 pl-2">
                                                            <h4>
                                                                <i class="fa fa-exclamation-circle pr-2"></i>
                                                                {{ employeeData.response.title }}</h4>
                                                            <p class="pt-2 pl-4 font-weight-semibold">{{ Lang.get('employerdashboard::pages/employee/transactions.explanation') }}:<br />
                                                                <span class="font-weight-lighter" v-html="employeeData.response.description"></span>
                                                            </p>
                                                            <p class="pt-2 pl-4 font-weight-semibold">{{ Lang.get('employerdashboard::pages/employee/transactions.reason') }}:<br />
                                                                <span class="font-weight-lighter" v-html="employeeData.response.reason"></span>
                                                            </p>
                                                        </div>
                                                    </template>

                                                    <template v-if="!employeeData.iob && employeeData.synced && !employee.is_anonymous">
                                                        <div class="bg-danger color-white py-2 pl-2">
                                                            <h4 class="color-white">
                                                                <i class="fa fa-exclamation-circle pr-2"></i>
                                                                {{ employeeData.response.title }}</h4>
                                                            <p class="pt-2 pl-4 font-weight-semibold">{{ Lang.get('employerdashboard::pages/employee/transactions.explanation') }}:<br />
                                                                <span class="font-weight-lighter" v-html="employeeData.response.description"></span>
                                                            </p>
                                                            <p class="pt-2 pl-4 font-weight-semibold">{{ Lang.get('employerdashboard::pages/employee/transactions.reason') }}:<br />
                                                                <span class="font-weight-lighter" v-html="employeeData.response.reason"></span>
                                                            </p>
                                                        </div>
                                                    </template>
                                                    <table class="table font-poppins font-weight-light font-size-14 color-blue" v-if=" Object.keys(employeeData.transactions).length">
                                                        <thead>
                                                        <tr>
                                                            <th>{{ Lang.get('employerdashboard::pages/employee/details.budgets.reference') }}</th>
                                                            <th>{{ Lang.get('employerdashboard::pages/employee/details.budgets.type_of_budget') }}</th>
                                                            <th>{{ Lang.get('employerdashboard::pages/employee/details.budgets.created_at') }}</th>
                                                            <th>{{ Lang.get('employerdashboard::pages/employee/details.budgets.total_incl') }}</th>
                                                            <th>{{ Lang.get('employerdashboard::pages/employee/details.budgets.invoice') }}</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="transaction in employeeData.transactions" class="card-body border-bottom font-poppins font-weight-light color-dark-blue pt-0 px-4">
                                                            <td>{{ transaction.reference }}</td>
                                                            <td>{{ transaction.method }}</td>
                                                            <td>{{ transaction.date }}</td>
                                                            <td>{{ transaction.total_incl | toCurrency }}</td>
                                                            <td>
                                                                <span v-if="!transaction.invoice">{{ Lang.get('employerdashboard::pages/employee/details.budgets.not_yet_invoiced') }}</span>
                                                                <inertia-link v-if="transaction.invoice && transaction.invoice.number" :href="route('nl.employerdashboard.invoice.details', {
                                                                company_as_uuid: $page.props.auth.user.selected_company.uuid,
                                                                invoice: transaction.invoice.uuid,
                                                            })">{{ transaction.invoice.number }}</inertia-link></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <pagination :links="employee.transactions.links" />
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-4">
                        <div class="row">
                            <div class="col-12 mb-4">
                                <SyncStatus :sync="sync"></SyncStatus>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/Search'
import throttle from 'lodash/throttle'
import SyncStatus from '@/Shared/SyncStatus'
import FlashMessages from "@/Shared/FlashMessages";

export default {
    metaInfo: { title: Lang.get('employerdashboard::pages/employees/index.title') },
    layout: Layout,
    components: {
        Pagination,
        SearchFilter,
        SyncStatus,
        FlashMessages
    },
    props: {
        employee: Object,
    },
    data() {
        return {
            sync: null,
        }
    },
    methods: {
        replaceSpace(value) {
            return value.replace(/ /g,'_');
        }
    },
}
</script>
